import React, { FC, useMemo } from 'react'
import { observer } from 'mobx-react'
import i18n from 'i18next'
import { memberMobx, memberCardMobx } from '@mobxStore'
import { ActivityAPI } from 'api/index'
import { find, each, keyBy } from '@dt/fe-utils/dist/lodash'
import { CouponItem, CouponDetail } from '@cps'
import { modalLayer, toast } from '@utils'
import './index.scss'

interface IProps {
  onChange?: () => void;
}

const CouponsGet: FC<IProps> = ({ onChange }) => {
  const { unacquiredCoupons } = memberMobx

  const goDetail = (data: any) => {
    modalLayer(CouponDetail, { type: 'get', couponInfo: data }, 'couponDetail')
  }
  const getCoupons = () => {
    memberMobx.acquiredCouponList().then(() => {
      toast({ message: i18n.t('mkt.coupon.receivedSucc') })
      onChange && onChange()
    })
  }

  const coupons: any = useMemo(() => {
    const list: any = []
    if (unacquiredCoupons.length) {
      const activeIds: number[] = []
      each(unacquiredCoupons, (item: any) => {
        const itemCoupons: any[] = []
        each(item.coupons, (child: any) => {
          for (let i = 0; i < child.couponCnt; i++) {
            itemCoupons.push(child)
          }
        })
        if (item.type === 'cardCouponPolicy') {
          const findCard: any = find(memberCardMobx.allCardList, (m: any) => `${m.cardId}` === `${item.remark}`)
          item.title = findCard ? findCard.cardName : i18n.t('pageName.card')
          item.des = item.remark ? i18n.t('mkt.member.getCouponTip1', { time: i18n.t(`mkt.member.sendTime${item.sendValue}`), number: item.coupons.length }) : ''
        } else if (item.type === 'memberCouponPolicy') {
          item.title = i18n.t('mkt.member.memberCouponPolicy')
        } else if (item.type === 'activityCoupon') {
          if (item.sendType === 'birthdayCoupon') {
            item.title = i18n.t('mkt.member.birthdayCoupon')
            item.des = i18n.t('mkt.member.birthdayCouponDes', { birthday: memberMobx.memberInfo.birthday })
          } else {
            if (!activeIds.includes(parseInt(item.outId))) {
              activeIds.push(parseInt(item.outId))
            }
          }
        }
        const obj: any = {
          ...item,
          coupons: itemCoupons,
        }
        list.push(obj)
      })
      if (activeIds.length > 0) {
        ActivityAPI.getActiveList({
          activityId: activeIds,
        }).then((res: any) => {
          if (!res.error) {
            const activeMap = keyBy(res, 'activityId')
            each(list, (item: any) => {
              const findActive: any = activeMap[parseInt(item.outId)]
              if (findActive) item.title = findActive.activityName
            })
            return list
          }
        })
      }
    }
    return list
  }, [unacquiredCoupons])

  return (
    <div className='my-coupons-get'>
      <div className='get-all-coupon'><span data-cypid='mmgGetCoupon' onClick={getCoupons}>{i18n.t('mkt.coupon.getAllCoupons')}</span></div>
      {
        coupons.map((item: any) => {
          return (
            <div className='get-coupon-area' key={item.outId}>
              <div className='header'>
                <div className='title'>{item.title}</div>
                {item.des && <div className='des'>{item.des}</div>}
              </div>
              <div className='coupon-list'>
                {
                  item.coupons.map((coupon: any, cIndex: number) => (
                    <div className='coupon-block' key={`${cIndex}-${coupon.couponId}`}>
                      <CouponItem type='get' couponInfo={coupon} onClick={goDetail}></CouponItem>
                    </div>
                  ))
                }
              </div>
            </div>
          )
        })
      }
    </div>
  )
}

export default observer(CouponsGet)
